import * as tokenService from './tokenService'
const BASE_URL = '/Webbridge'

export const fetchEvents= async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveEventsAll`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(reqBody)
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return null;
    } catch (error) {
        throw error
    }
}
export const fetchLimitedEvents = async (limitedEvents) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveLimitedEvents?limitedEvents=${limitedEvents}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${tokenService.getToken()}`
            },
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return null;
    } catch (error) {
        throw error
    }
}
export const fetchLimitedExhibitors = async (limitedExhibitors) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveLimitedExhibitors?limitedExhibitors=${limitedExhibitors}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${tokenService.getToken()}`
            },
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return null;
    } catch (error) {
        throw error
    }
}
export const fetchLimitedExhibitorLeadCapture = async (reqBody) => {
    const token = tokenService.getToken()
    try {
        const res = await fetch(`${BASE_URL}/RetrieveExhibitorLimitedAndLeadCapture`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(reqBody)
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
    } catch (error) {
        throw error
    }
}
export const fetchLimitedFullExhibitors = async (limitedExhibitors) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveLimitedFullExhibitors?limitedExhibitors=${limitedExhibitors}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${tokenService.getToken()}`
            },
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return null;
    } catch (error) {
        throw error
    }
}
export const getExhibitorLeads = async (limitedExhibitors) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveExhibitorLeads?limitedExhibitorIds=${limitedExhibitors}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${tokenService.getToken()}`
            },
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return null;
    } catch (error) {
        throw error
    }
}
export const generateExhibitorLeads = async (limitedExhibitors) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveExhibitorLeadsFile?limitedExhibitorIds=${limitedExhibitors}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${tokenService.getToken()}`
            },
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return null;
    } catch (error) {
        throw error
    }
}
export const emailExhibitorLeads = async (reqBody) => {
    const token = tokenService.getToken()
    try {
        const res = await fetch(`${BASE_URL}/EmailExhibitorLeads`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(reqBody)
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
    } catch (error) {
        throw error
    }
}

export const getExhibitorInvoices = async (limitedExhibitors) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveExhibitorInvoices?limitedExhibitorIds=${limitedExhibitors}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${tokenService.getToken()}`
            },
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return null;
    } catch (error) {
        throw error
    }
}
export const generateExhibitorInvoices = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveExhibitorInvoicesFile`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${tokenService.getToken()}`
            },
            body: JSON.stringify(reqBody)
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return null;
    } catch (error) {
        throw error
    }
}
export const emailExhibitorInvoices = async (reqBody) => {
    const token = tokenService.getToken()
    try {
        const res = await fetch(`${BASE_URL}/EmailExhibitorInvoices`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(reqBody)
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
    } catch (error) {
        throw error
    }
}
export const getExhibitorPasscodes = async (limitedExhibitors) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveExhibitorPasscodes?limitedExhibitorIds=${limitedExhibitors}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${tokenService.getToken()}`
            },
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return null;
    } catch (error) {
        throw error
    }
}
export const emailExhibitorPasscodes = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/EmailExhibitorPasscodes`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${tokenService.getToken()}`
            },
            body: JSON.stringify(reqBody)
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return null;
    } catch (error) {
        throw error
    }
}
export const generateExhibitorPasscodes = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveExhibitorPasscodesFile`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${tokenService.getToken()}`
            },
            body: JSON.stringify(reqBody)
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return null;
    } catch (error) {
        throw error
    }
}
export const fetchEventsByClient = async (clientId, includeTests) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveLeadCapturesByClientId?clientId=${clientId}&includeTests=${includeTests}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${tokenService.getToken()}`
            }
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return null;
    } catch (error) {
        throw error
    }
}
export const fetchClientsWithLeadCapture = async () => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveClientsWithEvents`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${tokenService.getToken()}`
            }
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return null;
    } catch (error) {
        throw error
    }
}
export const fetchLeadCapturesPaged = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveEventsBySearch`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(reqBody)
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return null;
    } catch (error) {
        throw error
    }
}

export const fetchLeadCaptureByRefNumber = async (refNumber) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveEventByRefNumber?refNumber=${refNumber}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return null;
    } catch (error) {
        throw error
    }
}

export const fetchExhibitorByInvoiceNumber = async (invoiceNumber) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveExhibitorByInvoiceNumber?invoiceNumber=${invoiceNumber}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return null;
    } catch (error) {
        throw error
    }
}
export const fetchExhibitorById = async (id) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveExhibitorById?id=${id}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return null;
    } catch (error) {
        throw error
    }
}
export const fetchExhibitorsByLeadCaptureId = async (id) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveExhibitorsByLeadCapture?id=${id}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return null;
    } catch (error) {
        throw error
    }
}

export const fetchAttachments = async () => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveAttachments`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return null;
    } catch (error) {
        throw error
    }
}
export const getCountries = async () => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveCountries`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return null;
    } catch (error) {
        throw error
    }
}
export const getStates = async () => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveAllStates`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return null;
    } catch (error) {
        throw error
    }
}
export const retrievePasscode = async (reqBody) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrievePasscode`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}


export const updateExhibitor = async (reqBody) => { 
    try {
        const res = await fetch(`${BASE_URL}/AddUpdateLCExhibitor`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(reqBody)
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const getConfirmationForm = async (refNumber, sendEmail) => {
    try {
        const res = await fetch(`${BASE_URL}/RetrieveConfirmationForm?refNumber=${refNumber}&sendEmail=${sendEmail}`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            })
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
        return null;
    } catch (err) {
        throw err
    }
}

export const getQualifierTypeOptions = async () => {
    const token = tokenService.getToken()
    try {
        const res = await fetch(`${BASE_URL}/RetrieveQualifierTypeOption`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const getExhibitorQualifiers = async (id) => {
    const token = tokenService.getToken()
    try {
        const res = await fetch(`${BASE_URL}/RetrieveExhibitorQualifiers?id=` + id, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
        if (res.status === 204) {
            return null
        }
        else if (res.status === 200) {
            return await res.json()
        }
    } catch (error) {
        throw error
    }
}

export const qualifierCheck = async (id) => {
    const token = tokenService.getToken()
    try {
        const res = await fetch(`${BASE_URL}/RetrieveQualifierUsage?id=` + id, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const deleteQualifier = async (id) => {
    const token = tokenService.getToken()
    try {
        const res = await fetch(`${BASE_URL}/RemoveQualifier?id=` + id, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
        if (res.status === 204 || res.status === 200) {
            return "Success"
        }
        else {
            return "error"
        }
    } catch (error) {
        throw error
    }
}
export const saveQualifier = async (reqBody) => {
    const token = tokenService.getToken()
    try {
        const res = await fetch(`${BASE_URL}/AddQualifier`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(reqBody)
        })
        if (res.status === 200) {
            return await res.json()
        }
        else if (res.status === 204) {
            return null
        }
        else {
            return await res.json()
        }
    } catch (error) {
        throw error
    }
}
export const saveQualifiers = async (reqBody) => {
    const token = tokenService.getToken()
    try {
        const res = await fetch(`${BASE_URL}/UpdateQualifiers`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(reqBody)
        })
        if (res.status === 200) {
            return await res.json()
        }
        else if (res.status === 204) {
            return null
        }
        else {
            return await res.json()
        }
    } catch (error) {
        throw error
    }
}
